import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { isEmpty } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

import { RootState } from '@share/utils';
import { GetWalletNumber } from '@share/utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

export function HeaderWalletMessage() {
  const intl = useIntl();

  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { account, user, userWallet, userWalletData } = loginStore;

  const hasClientCash = account?.hasClientCash;
  const isLoggedAshevillePlay = account?.isAshevillePlay && !user?.isAshevillePlayAdmin;
  const isLogged = !!userWallet || isLoggedAshevillePlay;

  if (!hasClientCash || !isLogged) {
    return null;
  }

  const clientCashName = isEmpty(account?.walletClientCashName)
    ? 'Client Cash'
    : account?.walletClientCashName;

  const tooltipOverlayProps = { overlayStyle: { zIndex: 4100 }, overlayClassName: 'header-wallet-message-tooltip' };

  return (
    <div className="header-wallet-message">
      <p className="header-wallet-message__title">Wallet</p>
      <p className="header__user-drawer-member">
        <FormattedMessage
          id="wallet.menu.active_cash"
          values={{
            clientCash: clientCashName,
          }}
        />
        {': '}
        {GetWalletNumber(userWalletData?.balance as number, account)}{' '}
        <Tooltip
          {...tooltipOverlayProps}
          title={intl.formatMessage(
            { id: 'wallet.menu.active_cash.tooltip' },
            { clientCash: clientCashName },
          )}
        >
          <FontAwesomeIcon icon={faCircleInfo} />
        </Tooltip>
      </p>

      {!account?.walletIsExternal ? (
        <p className="header__user-drawer-member">
          <FormattedMessage
            id="wallet.menu.pending_cash"
            values={{
              clientCash: clientCashName,
            }}
          />
          {': '}
          {GetWalletNumber(userWalletData?.pendingBalance as number, account)}{' '}
          <Tooltip
            {...tooltipOverlayProps}
            title={intl.formatMessage(
              { id: 'wallet.menu.pending_cash.tooltip' },
              { clientCash: clientCashName },
            )}
          >
            <FontAwesomeIcon icon={faCircleInfo} />
          </Tooltip>
        </p>
      ) : null}
    </div>
  );
}
